import { queryKey } from '@features/operations/api/useAllPlans'
import { locutusModifyPlanApi } from 'api-validations/locutus'
import { useOrgCodeOrThrow } from 'shared-ui/active-operation'
import { queryClient, useApiClient, useMutation } from 'shared-ui/api-provider'

/**
 * Mutation for deleting a plan from a field
 */
export const useDeletePlans = () => {
  const orgCode = useOrgCodeOrThrow()
  const apiClient = useApiClient()

  return useMutation({
    mutationFn: async ({ fieldId, planIds }: { fieldId: string; planIds: string[] }) => ({
      statuses: (
        await Promise.all(
          planIds.map((id) =>
            apiClient.delete(locutusModifyPlanApi.pathFor({ orgCode, fieldId, id }))
          )
        )
      ).map(({ status }) => status)
    }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKey, orgCode] })
      queryClient.invalidateQueries({ queryKey: [orgCode, 'field-plans'] })
    }
  })
}
